var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#0100C6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32422 9.94358C9.32422 8.46758 10.5242 7.26758 12.0002 7.26758C13.4762 7.26758 14.6762 8.46758 14.6762 9.94358C14.6762 10.8676 14.2082 11.6716 13.5122 12.1516",
    stroke: "#0100C6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.1523C12.864 12.6803 12 13.1123 12 14.0603",
    stroke: "#0100C6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0605V14.5765",
    stroke: "#0100C6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5215C12.3862 17.5215 12.6992 17.2084 12.6992 16.8223C12.6992 16.4361 12.3862 16.123 12 16.123C11.6138 16.123 11.3008 16.4361 11.3008 16.8223C11.3008 17.2084 11.6138 17.5215 12 17.5215Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/help-active.d64561b9f462ec0458ed6d163afbfd2e.svg";
export { ForwardRef as ReactComponent };